import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormUtils } from '../../../../../shared/helpers/formUtils';

@Component({
  selector: 'section-l',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './section-l.component.html',
  styleUrl: './section-l.component.css'
})
export class SectionLComponent implements OnInit, OnChanges{

  @Input() fullTeamAssessmentData: any;
  @Output() onSaveSection14 = new EventEmitter<any>();

  yesNo = EYesNo;
  sectionLForm: FormGroup = new FormGroup([]);

  radioQuestions = [
    {
      id: 'a_additional_info',
      questionText: 'A. Motives and Goals *',
      formControlName: 'a_additional_info'
    },
    {
      id: 'b_additional_info',
      questionText: 'B. Communications Suggesting Intent *',
      formControlName: 'b_additional_info'
    },
    {
      id: 'c_additional_info',
      questionText: 'C. Inappropriate or Concerning Interests *',
      formControlName: 'c_additional_info'
    },
    {
      id: 'd_additional_info',
      questionText: 'D. Attack Related Behaviors *',
      formControlName: 'd_additional_info'
    },
    {
      id: 'e_additional_info',
      questionText: 'E. Capacity to Carry Out Violence *',
      formControlName: 'e_additional_info'
    },
    {
      id: 'f_additional_info',
      questionText: 'F. Behavioral or Mental Health Concerns *',
      formControlName: 'f_additional_info'
    },
    {
      id: 'g_additional_info',
      questionText: 'G. Trusting Relationships *',
      formControlName: 'g_additional_info'
    },
    {
      id: 'h_additional_info',
      questionText: 'H. Violence as a Problem-Solving Method *',
      formControlName: 'h_additional_info'
    },
    {
      id: 'i_additional_info',
      questionText: 'I. Consistency between Story and Actions *',
      formControlName: 'i_additional_info'
    },
    {
      id: 'j_additional_info',
      questionText: 'J. Concerns about Potential for Violence *',
      formControlName: 'j_additional_info'
    },
    {
      id: 'k_additional_info',
      questionText: 'K. Additional Circumstances *',
      formControlName: 'k_additional_info'
    }
  ];

  constructor(
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fullTeamAssessmentData'] && this.fullTeamAssessmentData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      group[question.formControlName] = new FormControl(String(this.fullTeamAssessmentData?.[question.formControlName]) || this.yesNo.No, Validators.required);
    });   
    
    this.sectionLForm = new FormGroup(group);
  }

  saveSectionL(): void {
    if (this.sectionLForm.valid) {
      this.onSaveSection14.emit(this.sectionLForm.value);
    }
  }
}
